import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';
import { setOuterHTML } from 'next/javascripts/modules/utils';
import componentRenderedMixin from 'next/javascripts/mixins/component-rendered-mixin';
import { AVAILABLE_CODE_MODES } from './constants';
import 'codemirror/lib/codemirror.css';
import 'next/stylesheets/components/editor/content.scss';
import 'next/stylesheets/components/editor/output-renderer.scss';

function getCodeBlockLanguage(codeBlock) {
  let { lang } = codeBlock.dataset;
  if (lang) return lang;

  Array.from(codeBlock.classList).some((cls) => {
    // eslint-disable-next-line no-param-reassign
    cls = cls.replace(/^lang-/, '');
    if (AVAILABLE_CODE_MODES[cls]) lang = cls;
    return lang;
  });

  if (lang) return lang;

  Array.from(codeBlock.children).some((code) => {
    lang = getCodeBlockLanguage(code);
    return lang;
  });

  return lang;
}

Component('tr-editor-output-renderer', {
  mixins: [eventListenerMixin, componentRenderedMixin],

  properties: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.container = this.querySelector('.container');
    this.initImageLoading();

    if (this.rendered) return;

    this.checkContainerHeight();
    [...this.querySelectorAll('pre')].forEach(pre => this.highlightCodeBlock(pre));
    [...this.querySelectorAll('table')].forEach(table => this.wrapTableInFigure(table));
  },

  highlightCodeBlock(codeBlock) {
    import('./codemirror').then(({ default: CodeMirror }) => {
      const lang = getCodeBlockLanguage(codeBlock);
      const { mode } = AVAILABLE_CODE_MODES[lang] || {};
      if (!mode) return;

      codeBlock.classList.add('cm-s-default');
      CodeMirror.runMode(codeBlock.textContent, mode, codeBlock);
    });
  },

  initImageLoading() {
    const images = [...this.querySelectorAll('img')];
    images.forEach((img) => {
      if (img.complete) return;
      this.listenTo(img, 'load', () => {
        img.classList.remove('loading');
        this.checkContainerHeight();
      }, { once: true });
    });

    this.timer = setTimeout(() => {
      images.forEach((img) => {
        if (img.complete) return;
        img.classList.add('loading');
      });
    }, 500);
  },

  wrapTableInFigure(table) {
    const figure = closest(table, 'figure.table');

    if (!figure || !table.querySelector('colgroup')) {
      table.classList.add('full-width');
    }

    if (!figure) {
      setOuterHTML(table, `<figure class="table">${table.outerHTML}</figure>`);
    }
  },

  checkContainerHeight() {
    if (!this.container || this.collapsed) return;
    if (this.container.scrollHeight > this.container.offsetHeight) {
      this.renderCollapse();
    }
  },

  renderCollapse() {
    this.insertAdjacentHTML('beforeend', `
      <a class="link-expend" href="javascript:;">
        展开查看更多
        <span class="twr twr-angle-down"><span>
      </a>
    `);

    this.collapsed = true;
    this.listenTo(this.querySelector('.link-expend'), 'click', ({ target }) => {
      this.collapsed = false;
      this.container.style.maxHeight = 'none';
      target.remove();
    }, { once: true });
  },

  disconnected() {
    if (this.timer) clearTimeout(this.timer);
    this.stopListening();
  },
});
